(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details-teams.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details-teams.js');
"use strict";

const Initials = svs.components.marketplaceShared.initials.Initials;
const Shield = svs.components.lbUi.shield.Shield;
const useCompetitionId = svs.components.marketplaceCompetition.competitionContext.useCompetitionId;
const _svs$components$marke = svs.components.marketplaceCompetition.services.hooks,
  useCompetitionType = _svs$components$marke.useCompetitionType,
  useCompetitionBranding = _svs$components$marke.useCompetitionBranding;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const CompetitionDetailsTeams = _ref => {
  let _ref$drawResults = _ref.drawResults,
    drawResults = _ref$drawResults === void 0 ? [] : _ref$drawResults;
  const players = {};
  drawResults.forEach(draw => {
    if (draw) {
      const highestScore = draw.contributions.reduce((acc, prev) => acc > prev.correctCount ? acc : prev.correctCount, 0);
      draw.contributions.forEach(playerDraw => {
        if (!players[playerDraw.uid]) {
          players[playerDraw.uid] = {
            uid: playerDraw.uid,
            isAnonymous: playerDraw.isAnonymous,
            firstname: playerDraw.firstname,
            lastname: playerDraw.lastname,
            location: playerDraw.location,
            drawResults: {}
          };
        }
        players[playerDraw.uid].drawResults[draw.drawNumber] = {
          drawNumber: draw.drawNumber,
          correctCount: playerDraw.correctCount,
          isContributing: playerDraw.isContributing && draw.isContributing,
          hasPlayed: playerDraw.hasPlayed,
          hasHighestScore: playerDraw.correctCount === highestScore
        };
      });
    }
  });
  const competitionId = useCompetitionId();
  const compType = useCompetitionType(competitionId);
  const competitionBranding = useCompetitionBranding(compType);
  const getBrandingClass = result => {
    if (result !== null && result !== void 0 && result.hasPlayed && result !== null && result !== void 0 && result.isContributing) {
      if (result !== null && result !== void 0 && result.hasHighestScore) {
        return "shield-".concat(competitionBranding, "-gold");
      }
    } else {
      return "shield-".concat(competitionBranding, "-disabled");
    }
  };
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const sizeClass = isSmall ? 'shield-small' : 'shield-almost-medium';
  const hasShadow = false;
  return React.createElement("table", {
    className: "competition-details-teams-table"
  }, React.createElement("tr", null, React.createElement("td", null), Object.values(players).map(player => React.createElement("th", {
    className: "competition-details-teams-initials-th",
    key: player.uid,
    scope: "col"
  }, React.createElement(Initials, {
    firstname: player.firstname,
    isAnonymous: player.isAnonymous,
    isSimpleDiv: true,
    lastname: player.lastname
  })))), drawResults.map((result, i) => {
    const key = result ? "".concat(i, "_").concat(result.drawNumber) : i;
    return React.createElement("tr", {
      key: key
    }, React.createElement("th", {
      className: "competition-details-teams-drawnum-th",
      scope: "row"
    }, React.createElement("span", {
      className: "sr-only"
    }, "Omg\xE5ng ".concat(i + 1, ", ").concat(result.correctCount, " po\xE4ng.")), React.createElement("span", {
      "aria-hidden": "true",
      className: "competition-details-teams"
    }, React.createElement("span", {
      className: "competition-details-teams-drawnum"
    }, "Omg. ".concat(i + 1)), React.createElement("br", null), React.createElement("span", {
      className: "competition-details-teams-correctcount"
    }, "".concat(result.correctCount, "p")))), Object.values(players).map(player => {
      const playerResult = player.drawResults[result.drawNumber];
      const brandingClass = getBrandingClass(playerResult);
      const _ref2 = playerResult || {},
        _ref2$hasPlayed = _ref2.hasPlayed,
        hasPlayed = _ref2$hasPlayed === void 0 ? false : _ref2$hasPlayed,
        _ref2$isContributing = _ref2.isContributing,
        isContributing = _ref2$isContributing === void 0 ? false : _ref2$isContributing,
        _ref2$hasHighestScore = _ref2.hasHighestScore,
        hasHighestScore = _ref2$hasHighestScore === void 0 ? false : _ref2$hasHighestScore,
        _ref2$correctCount = _ref2.correctCount,
        correctCount = _ref2$correctCount === void 0 ? 0 : _ref2$correctCount;
      let correctCountMsg = "".concat(correctCount, " r\xE4tt").concat(hasPlayed && isContributing && hasHighestScore ? ', lagets bästa resultat.' : '.');
      if (hasPlayed && !isContributing) {
        correctCountMsg = "".concat(correctCount, " r\xE4tt, r\xE4knas ej p\xE5 grund av lagets l\xE4gsta resultat denna omg\xE5ng.");
      }
      return React.createElement("td", {
        className: "competition-details-teams-shield-td",
        key: player.uid
      }, React.createElement("span", {
        className: "sr-only"
      }, correctCountMsg), React.createElement(Shield, {
        branding: competitionBranding,
        className: [sizeClass, brandingClass].filter(Boolean).join(' '),
        hasAriaHidden: true,
        options: {
          hasShadow,
          hasHover: true
        }
      }, React.createElement("span", {
        className: "shield-value"
      }, hasPlayed ? correctCount : '-')));
    }));
  }));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.details.CompetitionDetailsTeams', CompetitionDetailsTeams);

 })(window);